import { inject } from '@angular/core';
import { AnhangDtoModel, ConfigSettingsService, ConverterService, EndToEndEncrypter } from '@ebeihilfe/core';
import { AnhangDataType } from '@ebeihilfe/einreichung-shared/model';
import { EinreichungApiService } from '@ebeihilfe/einreichung-shared/services';

import { Seite } from './Seite';

export abstract class SeiteFactory {
  protected readonly configService = inject(ConfigSettingsService);
  protected readonly converterService = inject(ConverterService);
  protected readonly einreichungsApi = inject(EinreichungApiService);
  protected readonly endToEndEncrypter = inject(EndToEndEncrypter);

  public abstract CreateSeite(): Seite;

  public async CreateFromSeitenInfo(seitenInfo: AnhangDtoModel): Promise<Seite> {
    const seite = this.CreateSeite();

    if (seitenInfo.thumbnail) {
      seite.dataType = seitenInfo.dataType as AnhangDataType;
      seite.id = seitenInfo.id;
      seite.thumb = seitenInfo.thumbnail;
      seite.uploaded = true;
      seite.setSize(seitenInfo.blobLen);
      return seite;
    }
    return seite;
  }
}
